"use strict";

angular.module("exploitation")

	.controller("ExploitNetworksCtrl", [
		"$scope", "$route", "ExploitationService", "MapService", "Utils", "$uibModal", "toastr", "SecurityService", "$location", "AdminService", "$timeout",
		function ($scope, $route, ExploitationService, MapService, Utils, $uibModal, toastr, SecurityService, $location, AdminService, $timeout) {

		/**************************************************************************************************************
		 * Configuration / init
		 **************************************************************************************************************/

		var networkModal,
			networkBackup;

		let timeoutSchemaExists;

		let getIfSchemaExists = function () {
			AdminService.doesSchemaExists(window.sessionStorage.getItem("referential")).then(response => {
				const res = response.data;
				if (res === "true" && $scope.data.isLoaded !== true) {
					$timeout.cancel(timeoutSchemaExists);
					window.location.reload();
				} else {
					timeoutSchemaExists = $timeout(() => getIfSchemaExists(), 5000);
				}
			})
			.catch(function () {
				timeoutSchemaExists = $timeout(() => getIfSchemaExists(), 5000);
			});
		}

		AdminService.doesSchemaExists(window.sessionStorage.getItem("referential"))
			.then(response => {
				const data = response.data;
				if (data !== "true") {
					$scope.data.isLoaded = false;
					getIfSchemaExists();
				} else {
					$scope.data.isLoaded = true;
				}
			})
			.catch( function () {
				getIfSchemaExists();
			});

		$scope.exploitationService = ExploitationService;
		$scope.utilsService = Utils;
		$scope.data.networkTypes = [
			{key: "SCHOLAR", value: "Scolaire"},
			{key: "COMMERCIAL", value: "Commercial"},
			{key: "SNCF", value: "SNCF"},
			{key: "TICKETING", value: "Commercial avec gestion de la billettique Korrigo"},
			{key: "URBAN", value: "Urbain"}
		];
		$scope.data.canDeleteNetwork = SecurityService.hasRight('canDeleteNetwork');
		$scope.data.isMarketing = SecurityService.hasRight('marketing');
		ExploitationService.setCurrentNetwork(undefined);


		/**************************************************************************************************************
		 * Scope functions
		 **************************************************************************************************************/


		$scope.networkSelected = function (networkId) {
			for (let networkIndex in $scope.data.networks) {
				if ("" + $scope.data.networks[networkIndex].id == "" + networkId) {
					ExploitationService.setCurrentNetwork($scope.data.networks[networkIndex]);
					$scope.data.selectedNetwork = $scope.data.networks[networkIndex];
					break;
				}
			}
		};

		$scope.isNetworkSelected = function (network) {
			if (ExploitationService.getCurrentNetwork()) {
				return network.id === ExploitationService.getCurrentNetwork().id;
			} else {
				return false;
			}
		};


		/**
		 * Edit a network in a modal.
		 * @param isNewNetwork the network to edit.
		 */
		$scope.openEditNetworkModal = function (isNewNetwork) {
			networkBackup = angular.copy($scope.data.selectedNetwork);
			if (isNewNetwork) {
				$scope.data.selectedNetwork = {networkType: "SCHOLAR"};
			}
			$scope.data.isNewNetwork = isNewNetwork;
			networkModal = Utils.openModal($uibModal, "editNetworkModal.html", $scope);
		};

		/**
		 * Annuler l'édition de la ligne et RAZ des valeurs.
		 */
		$scope.cancelEditNetwork = function () {
			networkModal.close();
			if (networkBackup) {
				for (let networkIndex in $scope.data.networks) {
					let network = $scope.data.networks[networkIndex];
					if (network.id === networkBackup.id) {
						$scope.data.networks[networkIndex] = networkBackup;
						$scope.data.selectedNetwork = networkBackup;
						break;
					}
				}
			}

		};


		$scope.goToNetworkOrganizationPage = function () {

			$location.path("e-iti/organisationReseaux/");
		};

		/**
		 * Post a new network.
		 * On successful return,
		 * - re-fetch networks
		 * - close the modal,
		 */
		$scope.postNetwork = function () {
			ExploitationService.editNetwork($scope.data.selectedNetwork, $scope.data.isNewNetwork)
				.then(() => {
					toastr.success($scope.data.isNewNetwork ? "Réseau créé avec succès" : "Réseau modifié avec succès", "");
					// refetch networks
					ExploitationService.getNetworks().then((response) => {
						const data = response.data;
						ExploitationService.updateNetworkCache(data);
						$scope.data.networks = data;
						networkModal.close();
					});
				})
				.catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de l'ajout du réseau.";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};


		/**
		 * Open network deletion modal confirmation.
		 */
		$scope.openDeleteNetworkModal = function () {
            networkModal = Utils.openModal($uibModal, "deleteNetworkModal.html", $scope);
		};


		/**
		 * Delete a network.
		 * On successful return,
		 * - re-fetch networks
		 * - close the modal,
		 */
		$scope.deleteNetwork = function () {
			ExploitationService.deleteNetwork($scope.data.selectedNetwork.id).then(() => {
				ExploitationService.setCurrentNetwork(undefined);
				$scope.data.currentNetwork = undefined;

				// refetch networks
				ExploitationService.getNetworks().then((response) => {
					const data = response.data;
					ExploitationService.updateNetworkCache(data);
					$scope.data.networks = data;
					networkModal.close();
					$scope.data.selectedNetwork = {};
					toastr.success("Réseau supprimé avec succès", "");
				})
				.catch(function () {
					$scope.deleteNetworkMessage = "Problème lors de la suppression du réseau.";
				});


			});
		};


		/**
		 * Supprimme les données topographiques (network et line) de la bdd locale du currentNetwork
		 * Et recharge la $route pour forcer le rechargement des données
		 */
		$scope.resetTopographieNetwork = function (networkId) {
		    if (networkId == null) {
		        networkId = ExploitationService.getCurrentNetwork().id;
			}
			const referential = window.sessionStorage.getItem("referential");
			ExploitationService.resetLocalDbNetwork(networkId, referential).then(() => {
				$route.reload();
				ExploitationService.setCurrentNetwork(undefined);
				$scope.data.currentNetwork = undefined;
			}).catch(function (error) {
				$route.reload();
				toastr.error("Erreur lors de la suppression des données locales de topographie: " + error, "");
			});
		};
	}]);
